import React from 'react';
import { LOGO, APP } from '../../config/appConfig';

export default function SplashLoader() {
  return (
    <div className="splash">
      <div className="splash-logo-wrap">
        <div className="splash-ring">
          <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="splashGrad" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#10b981" />
                <stop offset="100%" stopColor="#06b6d4" />
              </linearGradient>
            </defs>
            <circle cx="60" cy="60" r="52" />
          </svg>
        </div>
        <img className="splash-logo" src={LOGO} alt="logo" />
        <span className="splash-orbit" />
        <span className="splash-orbit b" />
        <span className="splash-orbit c" />
      </div>
      <div style={{ textAlign: 'center' }}>
        <div className="splash-title">{APP.name}</div>
        <div className="splash-sub">{APP.tagline}</div>
      </div>
      <div className="splash-bar" />
    </div>
  );
}
